import React, { ReactElement } from 'react';
import * as echarts from 'echarts/core';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { EChartsOption, LineSeriesOption } from 'echarts';

import {
  LineChart,
  BarChart,
  RadarChart,
  PieChart,
  // ScatterChart,
  // RadarChart,
  // MapChart,
  // TreeChart,
  // TreemapChart,
  // GraphChart,
  // GaugeChart,
  // FunnelChart,
  // ParallelChart,
  // SankeyChart,
  // BoxplotChart,
  // CandlestickChart,
  // EffectScatterChart,
  // LinesChart,
  // HeatmapChart,
  // PictorialBarChart,
  // ThemeRiverChart,
  // SunburstChart,
  // CustomChart,
} from 'echarts/charts';
// import components, all suffixed with Component
import {
  // GridSimpleComponent,
  GridComponent,
  PolarComponent,
  RadarComponent,
  // GeoComponent,
  // SingleAxisComponent,
  // ParallelComponent,
  // CalendarComponent,
  // GraphicComponent,
  // ToolboxComponent,
  TooltipComponent,
  // AxisPointerComponent,
  // BrushComponent,
  TitleComponent,
  // TimelineComponent,
  // MarkPointComponent,
  // MarkLineComponent,
  // MarkAreaComponent,
  LegendComponent,
  // LegendScrollComponent,
  // LegendPlainComponent,
  // DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  // VisualMapComponent,
  // VisualMapContinuousComponent,
  // VisualMapPiecewiseComponent,
  // AriaComponent,
  // TransformComponent,
  // DatasetComponent,
} from 'echarts/components';
// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import {
  CanvasRenderer,
  // SVGRenderer,
} from 'echarts/renderers';

interface ChartsEngineProps {
  options: EngineOptions;
  onEvents?: ChartsEngineEvents;
}

type EngineOptions = EChartsOption;

type LineChartSeriesOptions = LineSeriesOption;

type ChartsEngineEvents = Record<string, (params: unknown) => void>;

echarts.use([
  TitleComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  TooltipComponent,
  GridComponent,
  LineChart,
  BarChart,
  RadarChart,
  PieChart,
  CanvasRenderer,
  LegendComponent,
  PolarComponent,
  RadarComponent,
]);

function ChartsEngine({ options, onEvents }: ChartsEngineProps): ReactElement {
  return (
    <ReactEChartsCore
      option={options}
      notMerge={true}
      style={{ height: '100%' }}
      echarts={echarts}
      onEvents={onEvents}
    />
  );
}

export { ChartsEngine, type ChartsEngineEvents, type EngineOptions, type LineChartSeriesOptions };
